import React from 'react';
import { Box, ThemeProvider } from '@mui/material';
import { uiucTheme } from '../../styles/theme';
import Mast from './Mast';
import ClassSection from './ClassSection';
import DUSection from './DUSection';
import Navbar from '../../components/Navbar';

const UIUCPage: React.FC = () => {
  return (
    <Box
    sx={{
      background: uiucTheme.palette.background.default,
    }}
    > 
      <ThemeProvider theme={uiucTheme}>
        <Navbar /> 
      <Mast /> 
      <ClassSection />
      <DUSection />
      </ThemeProvider>
    </Box>
  );
};

export default UIUCPage;
